import "./style.scss";

import * as Yup from "yup";

import { FC, useContext, useState } from "react";
import { Field, Form, Formik } from "formik";

import Alert from "shared/ui/Alert";
import Button from "shared/ui/Button";
import Input from "shared/ui/Input";
import Select from "shared/ui/Select";
import { UserContext } from "features/account";
import { searchDarkDocuments } from "features/darkweb";
import SelectCountryEU from "shared/ui/SelectCountryEU";
import { documentNumberSchema } from "utils/documentEU_regex";

interface FormValues {
    documentNumber: string;
    documentType: string;
    documentCountry: string;
}

const options = [
    { value: "passport", label: "Passeport" },
    { value: "id", label: "Carte d'identité" },
    { value: "residency_permit", label: "Carte de séjour" },
    { value: "driver_permit", label: "Permis de conduire" },
];


type VerifyDarkWebDocumentProps = {
    type: string;
    setType: (type: string) => void;
    setVerificationDone:  (done: boolean) => void;
    verificationDone: boolean;
    setVerificationResult: React.Dispatch<React.SetStateAction<any>>;
    setdocumentinfos: (number: string, type:string, country: string) => void;
};

const VerifyDarkWebDocument: FC<VerifyDarkWebDocumentProps> = ({
     type,
     setType,
     setVerificationDone, 
     setVerificationResult,
     setdocumentinfos
}) => {
    const [result, setResult] = useState<any>();
    const { userType, user } = useContext(UserContext);
    const [countryCode, setCountryCode] = useState('FRA');


    const handleCheckDarkWeb = async (number: string, typeDocument: string, pays: string) => {

        try {
            const res = await searchDarkDocuments(number, type, typeDocument, pays, user?.companyName);
            if (res) {
                // console.log("DOCU SUR LE DARKWEB");
                setVerificationResult({ ...result, darkWeb: true });
            } else {
                setVerificationResult({ ...result, darkWeb: false });
            }
        } catch (error) {
            // console.error(error);
        }
        setVerificationDone(true);
    };

    const handleSubmit = async (values: FormValues) => {

        await handleCheckDarkWeb(values.documentNumber.toUpperCase(), values.documentType, values.documentCountry);
        setdocumentinfos(values.documentNumber.toUpperCase(), values.documentType, values.documentCountry);

    };

    return (
        <div className="VerifyDatabaseDocument h-100 d-flex flex-column ">
            <h1 className="VerifyDatabaseDocument__title h3">
                Votre document d'identité est-il sur le Dark Web?
            </h1>

            
                <Formik
                    initialValues={{ documentNumber: "", documentType: "", documentCountry: countryCode }}
                    validationSchema={Yup.object().shape({
                        documentNumber: documentNumberSchema(type, countryCode),
                        documentType: Yup.string().required("Ce champ est requis"),
                        documentCountry: Yup.string().required("Ce champ est requis"),
                    })}
                    onSubmit={handleSubmit}>
                    {({ values, handleChange, handleSubmit, errors, isValid }: any) => (
                        <Form onSubmit={handleSubmit}>
                            <div className="d-flex flex-column align-items-center justify-content-evenly h-100 m-20 ">
                                <div className="w-100 ">
                                    <div className="d-flex gap-1 mb-1">
                                        <Field
                                            name="documentCountry"
                                            value={values.documentCountry}
                                            id="documentCountry"
                                        >
                                            {({ field, country }: any) => (
                                                <SelectCountryEU
                                                    field={field}
                                                    country={country}
                                                    handleChange={(value: string)=> {
                                                        setCountryCode(value);
                                                    }}
                                                />
                                            )}
                                        </Field>
                                        <Field
                                            name="documentType"
                                            onChange={handleChange}
                                            value={values.documentType}>
                                            {({ field }: any) => (
                                                <Select
                                                    className="w-50"
                                                    field={field}
                                                    placeholder="Type de document"
                                                    options={options}
                                                    handleChange={(value) => setType(value)}
                                                    errorMessage={!isValid ? errors.documentType : ""}
                                                />
                                            )}
                                        </Field>
                                    </div>

                                    <Input
                                        type="text"
                                        name="documentNumber"
                                        placeholder="n° de document"
                                        required
                                        onChange={handleChange}
                                        value={values.documentNumber}
                                        className="mb-1"
                                        errorMessage={!isValid ? errors.documentNumber : ""}
                                    />
                                    {values.documentNumber && <Alert type="info">ID Protect ne conserve aucune données utilisateur</Alert>}
                                    
                                    <div className="d-flex flex-column justify-content-between align-items-center w-100">
                                    <Button
                                    className="btn btn-primary  "
                                    label="Vérifier"
                                    disabled={!isValid || !values.documentNumber || !values.documentType}
                                    />
                                    </div>
                                    
                                </div>
                                
                            </div>
                        </Form>
                    )}
                </Formik>
            
        </div>
    );
};

export default VerifyDarkWebDocument;
